export const PAYMENT_METHOD = [
    {
        label: "Bank Account",
        value: "bank_account",
    },
    {
        label: "E-Wallet",
        value: "e_wallet",
    },
    {
        label: "Meeza Card",
        value: "mezza_card",
    },
];
export const E_WALLETS = [
    {
        label: "Vodafone",
        value: "vodafone",
    },
    {
        label: "Orange",
        value: "orange",
    },
    {
        label: "WE",
        value: "we",
    },
];

export const NATIONALITY = [
    {
        label: "Egyptian",
        value: "egyptian",
    },
    {
        label: "Syrian",
        value: "syrian",
    },
    {
        label: "Sudanian",
        value: "sudanian",
    },
    {
        label: "Libyan",
        value: "libyan",
    },
    {
        label: "Palestinian",
        value: "palestinian",
    },
    {
        label: "Yemeni",
        value: "yemeni",
    },
];

export const PLATFORMS = [
    {
        label: "Mobile App",
        value: "mobile",
    },
    {
        label: "Admin",
        value: "admin",
    },
];

export const LICENSE = [
    {
        label: "أولى",
        value: "first_class",
    },
    {
        label: "ثانية",
        value: "second_class",
    },
    {
        label: "ثالثة",
        value: "third_class",
    },
    {
        label: "خاصة",
        value: "special",
    },
];
